<span a3l-ui-snack-bar-icon [ngSwitch]="type">
  <a3l-ui-icon size="12" icon="info" *ngSwitchCase="'info'"></a3l-ui-icon>
  <a3l-ui-icon size="12" icon="warning" *ngSwitchCase="'warning'"></a3l-ui-icon>
  <a3l-ui-icon size="12" icon="check-circle" *ngSwitchCase="'success'"></a3l-ui-icon>
  <a3l-ui-icon size="8" icon="cross" *ngSwitchCase="'error'"></a3l-ui-icon>
</span>
<a3l-ui-snack-bar-content [innerHTML]="message"></a3l-ui-snack-bar-content>
